import React, { useEffect, useState } from "react";
import "mapbox-gl/dist/mapbox-gl.css";
import { Button } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import useDeliverySocket from "../../hooks/useDeliverySocket";
import { useMapboxMap } from "../../hooks/useMapboxMap";

const FullscreenMapPage = () => {
  const navigate = useNavigate();
  const { trackerLink } = useParams();
  const searchParams = new URLSearchParams(window.location.search);
  const [deliveryId, setDeliveryId] = useState(null);
  const {
    mapContainer,
    directionData,
    handleDirectionUpdate,
    handleBikerLocationUpdate,
    initializeMap,
  } = useMapboxMap(trackerLink);

  const { joinDeliveryRoom, leaveDeliveryRoom } = useDeliverySocket(
    null,
    null,
    handleBikerLocationUpdate,
    handleDirectionUpdate
  );

  useEffect(() => {
    const cleanup = initializeMap({ fullscreen: true });
    return cleanup;
  }, [trackerLink, initializeMap]);

  useEffect(() => {
    const delId = searchParams.get("deliveryId");
    if (delId) {
      setDeliveryId(delId);
    }
  }, [trackerLink]);

  useEffect(() => {
    if (deliveryId) {
      joinDeliveryRoom(deliveryId);
      return () => {
        leaveDeliveryRoom(deliveryId);
      };
    }
  }, [deliveryId, joinDeliveryRoom, leaveDeliveryRoom]);

  return (
    <div style={{ width: "100vw", height: "100vh", position: "relative" }}>
      <div
        ref={mapContainer}
        style={{ width: "100%", height: "100%", borderRadius: 0 }}
      />
      <Button
        icon={<ArrowLeftOutlined />}
        onClick={() => navigate(-1)}
        style={{
          position: "absolute",
          top: "20px",
          left: "20px",
          zIndex: 10,
          backgroundColor: "#fff",
          borderColor: "#ddd",
        }}
      >
        Back
      </Button>
      {directionData && (
        <div
          style={{
            position: "absolute",
            bottom: "20px",
            left: "20px",
            right: "20px",
            backgroundColor: "#fef3c7",
            border: "1px solid #fcd34d",
            borderRadius: "8px",
            padding: "12px",
            zIndex: 10,
            maxWidth: "400px",
          }}
        >
          <div
            style={{
              fontSize: "14px",
              fontWeight: "600",
              color: "#78350f",
              marginBottom: "8px",
            }}
          >
            Step {directionData.currentStep} of {directionData.totalSteps}
          </div>
          <div
            style={{ fontSize: "14px", color: "#92400e", marginBottom: "8px" }}
          >
            {directionData.instruction}
          </div>
          <div
            style={{
              fontSize: "12px",
              color: "#b45309",
              marginBottom: "8px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <span>
              {(directionData.distanceToNextStep / 1000).toFixed(1)}km to next
              step
            </span>
            <span>
              {Math.round(directionData.etaToDestination / 60)}m remaining
            </span>
          </div>
          <div
            style={{
              width: "100%",
              backgroundColor: "#fcd34d",
              borderRadius: "4px",
              height: "8px",
              marginBottom: "8px",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                backgroundColor: "#f59e0b",
                height: "8px",
                borderRadius: "4px",
                width: `${directionData.completionPercentage}%`,
              }}
            />
          </div>
          <div
            style={{ fontSize: "12px", color: "#92400e", textAlign: "right" }}
          >
            {directionData.completionPercentage}% complete
          </div>
        </div>
      )}
    </div>
  );
};

export default FullscreenMapPage;
